import script from "./HealthSuiteView.vue?vue&type=script&lang=ts&setup=true"
export * from "./HealthSuiteView.vue?vue&type=script&lang=ts&setup=true"

import "./HealthSuiteView.vue?vue&type=style&index=0&id=5a9e2499&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a9e2499"]])

export default __exports__